import { render, staticRenderFns } from "./ContentOfferSubmissions.vue?vue&type=template&id=6ce36b02&"
import script from "./ContentOfferSubmissions.vue?vue&type=script&lang=js&"
export * from "./ContentOfferSubmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports